import styled from 'styled-components';

export default styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 2em 1em;
  overflow-y: auto;

  .modal--content {
    background: #1a1d35;
    border-radius: 12px;
    width: 100%;
    max-width: 700px;
    display: flex;
    flex-direction: column;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
    margin: auto;
    max-height: 90vh;
  }

  .modal--header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1.5em 2em;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);

    h2 {
      font-size: 1.5rem;
      color: #fff;
      margin: 0 0 0.25em 0;
    }

    .step--indicator {
      font-size: 0.85rem;
      color: rgba(255, 255, 255, 0.6);
      margin: 0;
    }

    .close--btn {
      background: rgba(255, 255, 255, 0.1);
      border: none;
      width: 40px;
      height: 40px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      cursor: pointer;
      transition: background 0.2s;

      &:hover {
        background: rgba(255, 255, 255, 0.15);
      }
    }
  }

  .steps--indicator {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 0.5em;
    padding: 1.5em 2em;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.2);

    .step--item {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 0.5em;
      position: relative;
      text-align: center;

      &:not(:last-child)::after {
        content: '';
        position: absolute;
        top: 20px;
        left: calc(50% + 30px);
        width: calc(100% - 60px);
        height: 2px;
        background: rgba(255, 255, 255, 0.1);
        z-index: 0;
      }

      &.active {
        .step--number {
          background: ${({ theme }) => theme.primary};
          color: #fff;
          border-color: ${({ theme }) => theme.primary};
        }

        &:not(:last-child)::after {
          background: ${({ theme }) => theme.primary};
        }
      }

      &.current {
        .step--title {
          color: ${({ theme }) => theme.primary};
          font-weight: 700;
        }
      }

      .step--number {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: transparent;
        border: 2px solid rgba(255, 255, 255, 0.2);
        color: rgba(255, 255, 255, 0.4);
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 700;
        font-size: 1rem;
        z-index: 1;
        position: relative;
        flex-shrink: 0;
        transition: all 0.3s;
      }

      .step--info {
        display: flex;
        flex-direction: column;
        gap: 0.25em;

        .step--title {
          font-size: 0.85rem;
          font-weight: 600;
          color: rgba(255, 255, 255, 0.7);
          transition: all 0.3s;
        }

        .step--description {
          font-size: 0.7rem;
          color: rgba(255, 255, 255, 0.4);
          line-height: 1.3;
        }
      }
    }
  }

  .modal--body {
    padding: 2em 2.5em;
    overflow-y: auto;
    flex: 1 1 auto;

    .step--content {
      .step--header {
        margin-bottom: 2em;

        h3 {
          font-size: 1.4rem;
          color: #fff;
          margin: 0 0 0.5em 0;
          font-weight: 700;
        }

        p {
          font-size: 1rem;
          color: rgba(255, 255, 255, 0.6);
          margin: 0;
        }
      }

      .tabs--container {
        display: flex;
        gap: 0.5em;
        margin-bottom: 2em;
        border-bottom: 2px solid rgba(255, 255, 255, 0.1);

        .tab {
          padding: 0.75em 1.5em;
          background: transparent;
          border: none;
          color: rgba(255, 255, 255, 0.6);
          font-size: 0.95rem;
          font-weight: 500;
          cursor: pointer;
          position: relative;
          transition: all 0.2s;
          border-bottom: 2px solid transparent;
          margin-bottom: -2px;

          &:hover {
            color: rgba(255, 255, 255, 0.8);
          }

          &.active {
            color: ${({ theme }) => theme.primary};
            border-bottom-color: ${({ theme }) => theme.primary};
          }
        }
      }
    }

    .notice {
      background: rgba(255, 152, 0, 0.1);
      border: 1px solid rgba(255, 152, 0, 0.3);
      border-radius: 8px;
      padding: 1em 1.25em;
      margin-bottom: 2em;

      p {
        margin: 0;
        color: #FFA726;
        font-size: 0.85rem;
        line-height: 1.5;
      }
    }

    .form--section {
      margin-bottom: 2em;

      h3 {
        font-size: 1.1rem;
        color: #fff;
        margin: 0 0 1em 0;
      }

      .form--grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 1em;

        .form--group {
          display: flex;
          flex-direction: column;
          gap: 0.5em;

          &.full-width {
            grid-column: span 2;
          }

          label {
            font-size: 0.85rem;
            color: rgba(255, 255, 255, 0.7);
            font-weight: 500;
          }

          input,
          select,
          textarea {
            padding: 0.75em 1em;
            background: rgba(255, 255, 255, 0.05);
            border: 1px solid rgba(255, 255, 255, 0.1);
            border-radius: 8px;
            color: #fff;
            font-size: 1rem;
            font-family: inherit;
            transition: border-color 0.2s;

            &:focus {
              outline: none;
              border-color: ${({ theme }) => theme.primary};
            }

            &::placeholder {
              color: rgba(255, 255, 255, 0.3);
            }
          }

          textarea {
            resize: vertical;
            min-height: 80px;
          }

          select {
            cursor: pointer;
          }
        }
      }
    }

    .form--grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 1em;

      .form--group {
        display: flex;
        flex-direction: column;
        gap: 0.5em;

        &.full-width {
          grid-column: span 2;
        }

        label {
          font-size: 0.85rem;
          color: rgba(255, 255, 255, 0.7);
          font-weight: 500;
        }

        input,
        select,
        textarea {
          padding: 0.75em 1em;
          background: rgba(255, 255, 255, 0.05);
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 8px;
          color: #fff;
          font-size: 1rem;
          font-family: inherit;
          transition: border-color 0.2s;

          &:focus {
            outline: none;
            border-color: ${({ theme }) => theme.primary};
          }

          &::placeholder {
            color: rgba(255, 255, 255, 0.3);
          }
        }

        textarea {
          resize: vertical;
          min-height: 80px;
        }

        select {
          cursor: pointer;
        }
      }
    }
  }

  .modal--footer {
    padding: 1.5em 2em;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    display: flex;
    justify-content: space-between;
    gap: 1em;

    .footer--left,
    .footer--right {
      display: flex;
      gap: 1em;
    }

    .btn {
      padding: 0.75em 1.5em;
      border-radius: 8px;
      font-weight: 600;
      cursor: pointer;
      transition: opacity 0.2s;
      border: none;
      font-size: 1rem;
      display: flex;
      align-items: center;
      gap: 0.5em;

      .btn-icon {
        font-size: 0.9rem;
      }

      &:hover:not(:disabled) {
        opacity: 0.9;
      }

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }

      &--secondary {
        background: rgba(255, 255, 255, 0.1);
        color: #fff;
      }

      &--primary {
        background: ${({ theme }) => theme.primary};
        color: #fff;
      }
    }
  }

  .loading--screen,
  .success--screen,
  .error--screen {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 4em 2em;
    text-align: center;
    min-height: 400px;

    h3 {
      font-size: 1.5rem;
      color: #fff;
      margin: 1em 0 0.5em 0;
    }

    p {
      color: rgba(255, 255, 255, 0.7);
      font-size: 1rem;
      margin: 0;
    }

    .btn {
      margin-top: 2em;
      padding: 0.75em 2em;
      border-radius: 8px;
      font-weight: 600;
      cursor: pointer;
      transition: opacity 0.2s;
      border: none;
      font-size: 1rem;

      &--primary {
        background: ${({ theme }) => theme.primary};
        color: #fff;

        &:hover {
          opacity: 0.9;
        }
      }
    }
  }

  .loading--screen {
    .spinner--wrapper {
      margin-bottom: 1em;
    }

    .spinner {
      width: 60px;
      height: 60px;
      border: 4px solid rgba(255, 255, 255, 0.1);
      border-top-color: ${({ theme }) => theme.primary};
      border-radius: 50%;
      animation: spin 1s linear infinite;
    }

    @keyframes spin {
      to {
        transform: rotate(360deg);
      }
    }
  }

  .success--screen {
    .success--icon {
      margin-bottom: 1em;
      animation: scaleIn 0.5s ease-out;

      svg {
        animation: checkmark 0.6s ease-in-out 0.3s both;
      }
    }

    .tracking--info {
      margin-top: 2em;
      padding: 1em 2em;
      background: rgba(16, 185, 129, 0.1);
      border: 1px solid rgba(16, 185, 129, 0.3);
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      gap: 0.5em;

      span {
        font-size: 0.85rem;
        color: rgba(255, 255, 255, 0.6);
      }

      strong {
        font-size: 1.2rem;
        color: #10b981;
        font-family: monospace;
      }
    }

    @keyframes scaleIn {
      from {
        transform: scale(0);
        opacity: 0;
      }
      to {
        transform: scale(1);
        opacity: 1;
      }
    }

    @keyframes checkmark {
      0% {
        stroke-dashoffset: 100;
      }
      100% {
        stroke-dashoffset: 0;
      }
    }
  }

  .error--screen {
    .error--icon {
      margin-bottom: 1em;
      animation: shake 0.5s ease-in-out;
    }

    @keyframes shake {
      0%, 100% {
        transform: translateX(0);
      }
      25% {
        transform: translateX(-10px);
      }
      75% {
        transform: translateX(10px);
      }
    }
  }
`;
